import { InputField, SelectField } from "../../../lib";
import useClassesOptions from "../../../lib/Hooks/options/useClassesOption";
import { FieldArray, useFormikContext } from "formik";
import { AddNoteProps } from "../../../lib/Types/NoteProps";
import Editor from "../../shared/Quill/Editor";
import useCallToActionOptions from "../../../lib/Hooks/options/useCalltoActionOption";
import useBehaviorOptions from "../../../lib/Hooks/options/useBehaviorOption";
import MoveDotsIcon from "../../../assets/MoveDots";
import { PAGE_FOR } from "@pages/pagefor";
import {
  MainFieldContainer,
  MainFieldContainer1,
  FieldContainer,
  EditorContainer,
  EditorRowContainer,
  AddStep,
  Steps,
  Delete,
} from "src/styles/Containers";
import { Title } from "src/styles/Typography";

interface AddNoteFieldsProps {
  isEdit?: boolean;  // isEdit duplicate or edit
  pageFor?: PAGE_FOR
}

function AddNoteFields({ isEdit, pageFor }: AddNoteFieldsProps) {
  const formikProps = useFormikContext();
  const classesOptions = useClassesOptions();
  const callToActionOptions = useCallToActionOptions();
  const behaviorOptions = useBehaviorOptions();

  function isFieldDisabled(property: string) {
    if(pageFor==='admin') return false
    if(isEdit == false) return false
    let note = (formikProps.values as AddNoteProps);
    let disabled = false;
    if (note.noteType != undefined)
      switch (true) {
        case note.isSystem && note.noteType.indexOf("RITUAL") == 0 && property == 'title':
          disabled = true;
          break;
        case note.isSystem && note.noteType.indexOf("RECORD_STATS") == 0 &&
          property != "notificationText":
          disabled = true;
          break;
      }
    return disabled ? "disabled" : "";
  }
  function isFieldDisabledBoolean(property: string) {
    if(pageFor==='admin' || pageFor==='coach') return false
    if(isEdit == false) return false
    let note = (formikProps.values as AddNoteProps);
    let disabled = false;
    if (note.noteType != undefined)
      switch (true) {
        case note.isSystem && note.noteType.indexOf("RITUAL") == 0 && property == 'title':
          disabled = true;
          break;
        //disable everything except notificatintext for recordstats
        case note.isSystem && note.noteType.indexOf("RECORD_STATS") == 0 &&
          property != "notificationText":
          disabled = true;
          break;
      }
    return disabled;
  }

  return (
    <FieldContainer>
      <MainFieldContainer>
        <MainFieldContainer1>
          <Title>{"General"}</Title>
          <InputField
            placeholder={"Note Title*"}
            name={"title"}
            disabled={isFieldDisabled("title")}
          />
          <InputField
            placeholder={"Notification Text*"}
            name={"notificationText"}
            disabled={isFieldDisabled("notificationText")}
          />
          <SelectField
            name={"behaviorId"}
            placeholder={"Behaviour to Eliminate or Create"}
            options={behaviorOptions}
            disabled={isFieldDisabledBoolean("behaviorId")}
          />
          <SelectField
            name={"callToActionId"}
            placeholder={"Call to Action"}
            options={callToActionOptions}
            disabled={isFieldDisabledBoolean("callToActionId")}
          />
        </MainFieldContainer1>
      </MainFieldContainer>
      <div style={{ width: "100%" }}>
        <FieldArray
          name='noteSteps'
          render={(arrayHelpers) => (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              {(formikProps.values as AddNoteProps).noteSteps &&
              (formikProps.values as AddNoteProps).noteSteps.length > 0
                ? (formikProps.values as AddNoteProps).noteSteps.map(
                    (note: any, index: number) => (
                      <EditorContainer key={index}>
                        <EditorRowContainer>
                          <Steps>
                            <MoveDotsIcon
                              sx={{
                                height: "16px",
                                width: "16px",
                                verticalAlign: "baseline",
                              }}
                            ></MoveDotsIcon>{" "}
                            Step {index + 1}
                          </Steps>
                          {!isFieldDisabledBoolean("deleteSteps") && (
                            <Delete
                              style={{
                                visibility:
                                  (formikProps.values as AddNoteProps).noteSteps
                                    .length == 1
                                    ? "hidden"
                                    : "visible",
                              }}
                              onClick={() => {
                                arrayHelpers.remove(index);

                              let deleteIndex = index;
                              let totalNotes =(formikProps.values as AddNoteProps).noteSteps.length - 1;
                              while(deleteIndex <= totalNotes){
                                let nextIndex = deleteIndex + 1;
                                if(nextIndex <= totalNotes)
                                  formikProps.setFieldValue(
                                  `noteSteps${deleteIndex}.text`,
                                  (formikProps.values as any)[`noteSteps${nextIndex}`].text
                                  );
                                deleteIndex++;
                              }

                              //set last value to blank so that when we add step we get blank step
                              formikProps.setFieldValue(
                                `noteSteps${(formikProps.values as AddNoteProps).noteSteps.length - 1}.text`,
                                ''
                                );
                              
                              }}
                            >
                              {" "}
                              Delete
                            </Delete>
                          )}
                        </EditorRowContainer>
                        <EditorRowContainer className={`${isFieldDisabledBoolean("noteSteps") ? "disabled-quill" : ""}`}>
                          <Editor
                            name={`noteSteps${index}.text`}
                            placeholder={"description"}
                            formikProps={formikProps}
                            readonly={isFieldDisabledBoolean("noteSteps")}
                          />
                        </EditorRowContainer>
                      </EditorContainer>
                    )
                  )
                : null}
              {!isFieldDisabledBoolean("addSteps") && (
                <AddStep
                  onClick={() => {
                    arrayHelpers.push({ text: "" });
                  }}
                >
                  + Add Step
                </AddStep>
              )}
            </div>
          )}
        />
      </div>
    </FieldContainer>
  );
}

export default AddNoteFields;
